/**
 * Store sub context for feature data
 * */
const FeatureContext = {
  isCSCEnabled: true,
  isCNEdEnabled: true,
  isNLRValidationEnabled: true,
  isAIDETValidationEnabled: true,
  isBSSRValidationEnabled: true
};

export default FeatureContext;
